<template>
  <div v-if="cart_ready" class="margin-top-1-5">
    <a
      v-if="is_in_cart"
      class="button-grey"
      :class="{ isAdded: added }"
      :href="cart_url"
    >
      Item In Cart
    </a>
    <p v-else-if="added">
      <a class="button-grey" :class="{ isAdded: added }" :href="cart_url">
        View Cart
      </a>
    </p>
    <p
      v-else-if="product_url === 'trendsreport' && has_sub == true"
      class="double-buttons"
    >
      <a class="button-green" v-if="upgradeable">Upgrade</a>
      <a class="button-grey" v-else>Already Subscribed</a>
    </p>
    <p
      v-else-if="product_url === 'trendsreport' && has_used_tr_free_trial == 0"
      class="double-buttons"
    >
      <a class="button-green" @click="addToCart">Add To Cart</a>
      <a :href="free_trial_link" class="button-grey">Free Trial</a>
    </p>

    <p
      v-else-if="
        product_url === 'by-the-numbers-free-trial' && has_used_btn_free_trial
      "
    >
      <!-- leaving this empty for now -->
    </p>

    <p v-else-if="has_trial == true" class="double-buttons">
      <a class="button-green" @click="addToCart">Purchase Full Subscription</a>
    </p>

    <p v-else-if="has_sub == true" class="double-buttons">
      <a class="button-grey">Already Subscribed</a>
    </p>
    <p v-else>
      <a class="button-green" v-if="eligible_for_upgrade" @click="upgrade()">
        Upgrade
      </a>
      <a class="button-green" @click="addToCart" v-else>Add To Cart</a>
    </p>
  </div>
  <BaseModal
    v-if="isShowing"
    @background-clicked="handleBackgroundClicked()"
    rounded
    dropShadow
    size="sm"
    :noPadding="true"
  >
    <div class="subscription-modal">
      <h2 class="subscription-modal__title">
        Let's Upgrade Your Subscription!
      </h2>
      <p class="subscription-modal__subtitle">
        When you upgrade your subscription, you'll receive instant access to
        your new subscription components, and your bundle will automatically
        renew on {{ renewelDate }}.
        <br />
        <br />
        Your first bundle billing will be prorated to include your current
        subscription, as seen at checkout on the next page.
      </p>
      <div class="subscription-modal__button-container">
        <a @click="addToCart()" class="button-green subscription-modal__button">
          head to cart
        </a>
        <a
          @click="handleBackgroundClicked()"
          class="button-charcoal subscription-modal__button"
        >
          cancel
        </a>
      </div>
    </div>
  </BaseModal>
</template>

<script>
  import axios from 'axios';
  import { useCartStore } from '~/stores/cart';
  import BaseModal from '~/components/base/BaseModal.vue';

  export default {
    components: {
      BaseModal,
    },
    props: {
      product_url: {
        Type: String,
        required: false,
      }, 
      type_of_product: {
        Type: String,
        required: false,
      },
      cart_url: {
        Type: String,
        required: false,
      },
      is_in_cart: {
        Type: Boolean,
        required: false,
      },
      free_trial_link: {
        Type: String,
        required: false,
      },
      has_used_tr_free_trial: {
        Type: Boolean,
        required: false,
      },
      has_used_insider_free_trial: {
        Type: Boolean,
        required: false,
      },
      has_used_btn_free_trial: {
        Type: Boolean,
        required: false,
      },
      has_used_insider_promo: {
        Type: Boolean,
        required: false,
      },
      has_used_btn_promo: {
        Type: Boolean,
        required: false,
      },
      has_sub: {
        Type: Boolean,
        required: false,
      },
      has_trial: {
        Type: Boolean,
        required: false,
      },
      has_tr_sub: {
        Type: Boolean,
        required: false,
      },
      eligible_for_upgrade: {
        Type: Boolean,
        required: false,
      },
      upgradeable: {
        Type: Boolean,
        required: false,
      },
    },
    setup() {
      const cartStore = useCartStore();
      return { cartStore };
    },
    data: () => ({
      product: '',
      added: false,
      show: true,
      cart_ready: false,
      isShowing: false,
    }),
    mounted() {
      this.fetchItemDetails();
    },
    computed: {
      renewelDate() {
        if (this.product.bundleCalculator) {
          const date = new Date(this.product.bundleCalculator.next_renewal);
          const adjustedDate = new Date(
            date.getTime() + date.getTimezoneOffset() * 60000
          );
          return `${adjustedDate.getMonth() + 1}/${adjustedDate.getDate()}/${adjustedDate.getFullYear()}`;
        }
      },
    },
    methods: {
      async fetchItemDetails() {
        try {
          const { data } = await axios.get('/cart/product-details', {
            params: {
              type: this.type_of_product,
              url: this.product_url,
            },
          });
          this.product = data.data;
          this.cart_ready = true;
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async addToCart() {
        try {
          const promoPrice = this.promoPriceCheck();
          await this.cartStore.addItem({
            type: this.type_of_product,
            url: this.product.url,
            sku: this.product.sku,
            annual_sku: this.product.annual_sku,
            name: this.product.name,
            price: this.product.price,
            promo_price: promoPrice,
            qty: 1,
            billing_period: this.product.billing_period,
            is_free_trial: this.product.is_free_trial,
            is_shipped: this.product.is_shipped,
            ounce_weight: this.product.ounce_weight,
            pound_weight: this.product.pound_weight,
            bundle_calculator: this.product.bundleCalculator
              ? this.product.bundleCalculator
              : null,
          });
          this.added = true;
          if (
            this.product.sku == 6314346 &&
            !this.has_used_tr_free_trial &&
            !this.has_tr_sub
          ) {
            this.pushTrendsReportTrial();
          } else if (
            this.product.sku == 6314347 &&
            this.is_free_trial &&
            !this.has_used_insider_free_trial &&
            !this.has_insider_sub
          ) {
            this.pushInsiderTrial();
          } else {
            window.location.href = '/cart';
          }
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async pushTrendsReportTrial() {
        try {
          const promoPrice = this.promoPriceCheck();
          await this.cartStore.addItem({
            type: 'Subscription',
            url: 'trendsreport-free-trial',
            sku: '6421166',
            annual_sku: '6421166',
            name: 'Trends Report (Free Trial)',
            price: '0.00',
            promo_price: promoPrice,
            qty: 1,
            billing_period: 'free_trial',
            is_free_trial: 1,
            is_shipped: 0,
            ounce_weight: null,
            pound_weight: null,
          });
          this.added = true;
          window.location.href = '/cart';
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      async pushInsiderTrial() {
        try {
          const promoPrice = this.promoPriceCheck();
          await this.cartStore.addItem({
            type: 'Subscription',
            url: 'insider-free-trial',
            sku: '6314347', // insider trial sku needed
            annual_sku: '6314347',
            name: 'Insider (Free Trial)',
            price: '0.00',
            promo_price: promoPrice,
            qty: 1,
            billing_period: 'free_trial',
            is_free_trial: 1,
            is_shipped: 0,
            ounce_weight: null,
            pound_weight: null,
          });
          this.added = true;
          window.location.href = '/cart';
        } catch (error) {
          // TODO: HANDLE ERROR - This is just silencing the error
        }
      },
      promoPriceCheck() {
        if (
          (this.product_url === 'insider' ||
            this.product_url === 'insider-annual') &&
          this.has_used_insider_promo === '1'
        )
          return null;
        if (
          (this.product_url === 'by-the-numbers' ||
            this.product_url === 'by-the-numbers-annual') &&
          this.has_used_btn_promo === '1'
        )
          return null;
        return this.product.promo_price;
      },
      upgrade() {
        this.isShowing = true;
      },
      handleBackgroundClicked() {
        this.isShowing = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .margin-top-1-5 {
    margin-top: 1.5em !important;
  }
  .isAdded {
    text-decoration: line-through;
  }
  .bounce-enter-active {
    animation: bounce-in 0.5s;
  }
  .bounce-leave-active {
    animation: bounce-in 0.5s reverse;
  }
  .subscription-modal {
    padding: 28px;
    text-align: center;
    margin: auto;
    &__title {
      margin-bottom: 2rem;
      font-weight: 700;
      color: var(--itr-blue);
      @include screen-md {
        font-size: 30px;
      }
    }
    &__subtitle {
      margin-bottom: 1.5rem;
      font-size: 18px;
      font-weight: 700;
      color: var(--itr-charcoal);
    }
    &__button {
      padding: 4px !important;
      margin: 10px 5px 0px 5px;
      width: 250px;
    }
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.5);
    }
    100% {
      transform: scale(1);
    }
  }
</style>
